import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import SearchableSelect from "../Common/SearchableSelect";

const CreateQtyLayer = () => {
  const { AsyncPostApiCall, AsyncGetApiCall } = useApi();
  const [accountType, setAccountType] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [accountTypes, setAccountTypes] = useState([]);

  useEffect(() => {
    const fetchAccountTypes = async () => {
      const result = await AsyncGetApiCall("/trading-settings/account-type");
      if (result?.success) {
        setAccountTypes(result.data || []);
      }
    };
    fetchAccountTypes();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleDownloadTemplate = () => {
    const headers = [
      "segment",
      "script_name",
      "position",
      "min_order",
      "max_order",
      "quantity_lot",
    ];
    const content = headers.join(",") + "\n";
    const blob = new Blob([content], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "quantity_settings_template.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select a CSV file");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      if (accountType) {
        formData.append("accountType", accountType);
      }

      const result = await AsyncPostApiCall(
        "/trading-settings/quantity/upload",
        formData,
      );

      if (result?.success) {
        toast.success(result.message || "File uploaded successfully");
        setAccountType("");
        setFile(null);
        // Reset file input
        e.target.reset();
      } else {
        toast.error(result?.message || "Upload failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="card radius-16 border-0 shadow-sm mb-24">
        <div className="card-header bg-primary-600 py-16 px-24 d-flex align-items-center gap-2 text-white">
          <Icon icon="tabler:settings" className="icon text-xl" />
          <h6 className="text-white mb-0">Create Quantity Settings</h6>
        </div>
        <div className="card-body p-24">
          <div className="mb-24">
            <button
              type="button"
              className="btn btn-success radius-8 px-20 py-10 d-flex align-items-center gap-2"
              onClick={handleDownloadTemplate}
            >
              <Icon icon="lucide:download" className="icon" />
              Download Standard Quantity File
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row g-4 align-items-center mb-24">
              <div className="col-auto" style={{ width: "150px" }}>
                <label className="form-label mb-0 fw-semibold text-secondary-light">
                  ACCOUNT TYPE
                </label>
              </div>
              <div className="col-md-4">
                <div style={{ position: "relative", zIndex: 20 }}>
                  <SearchableSelect
                    placeholder="Select Account Type"
                    value={accountType}
                    onChange={(e) => setAccountType(e.target.value)}
                    options={accountTypes.map((type) => ({
                      label: type.name,
                      value: type.name,
                    }))}
                  />
                </div>
              </div>
            </div>

            <div className="row g-4 align-items-center mb-24">
              <div className="col-auto" style={{ width: "150px" }}>
                <label className="form-label mb-0 fw-semibold text-secondary-light">
                  FILE (CSV)
                </label>
              </div>
              <div className="col-md-4">
                <input
                  type="file"
                  className="form-control radius-8"
                  accept=".csv, .xlsx, .xls"
                  onChange={handleFileChange}
                />
              </div>
            </div>

            <div className="mt-32">
              <button
                type="submit"
                className="btn btn-primary radius-8 px-32 py-10 d-flex align-items-center gap-2"
                disabled={loading}
              >
                <Icon icon="tabler:plus" className="icon" />
                Add
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateQtyLayer;
